// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HzSYMZxGxiOnq43coE7b{margin:0 32px;box-sizing:border-box}.edADn9zv58IVX8uM3IZB{white-space:pre-wrap}.je9VTNMUR8LzfyJeTwkG{border:1px solid #e0e0e0;padding:16px;border-radius:8px}`, "",{"version":3,"sources":["webpack://./src/Pages/jira-tools/views/triage-ticket/styles.styl"],"names":[],"mappings":"AAAA,sBACI,aAAO,CACP,qBAAW,CAEf,sBACI,oBAAY,CAEhB,sBACI,wBAAO,CACP,YAAQ,CACR,iBAAc","sourcesContent":[".container\n    margin 0 32px\n    box-sizing border-box\n\n.results\n    white-space pre-wrap\n\n.copilot\n    border 1px solid #e0e0e0\n    padding 16px\n    border-radius 8px\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `HzSYMZxGxiOnq43coE7b`,
	"results": `edADn9zv58IVX8uM3IZB`,
	"copilot": `je9VTNMUR8LzfyJeTwkG`
};
export default ___CSS_LOADER_EXPORT___;
